import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setProjectField } from '../modules/project/actions';

/**
 * Ersetzt das frühere ProjectContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `project.xxx`/`project.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useProjectState() {
    const project = useSelector((state) => state.project);
    const dispatch = useDispatch();

    const setProjects = useCallback((value) => dispatch(setProjectField('projects', value)), [dispatch]);
    const setUserProjects = useCallback((value) => dispatch(setProjectField('userProjects', value)), [dispatch]);
    const setClicked = useCallback((value) => dispatch(setProjectField('clicked', value)), [dispatch]);
    const setIsLoaded = useCallback((value) => dispatch(setProjectField('isLoaded', value)), [dispatch]);
    const setUserProjectIsLoaded = useCallback((value) => dispatch(setProjectField('userProjectIsLoaded', value)), [dispatch]);
    const setSelected = useCallback((value) => dispatch(setProjectField('selected', value)), [dispatch]);

    return {
        projects: project.projects, setProjects,
        userProjects: project.userProjects, setUserProjects,
        clicked: project.clicked, setClicked,
        isLoaded: project.isLoaded, setIsLoaded,
        userProjectIsLoaded: project.userProjectIsLoaded, setUserProjectIsLoaded,
        selected: project.selected, setSelected,
    };
}
